module.exports = __webpack_public_path__ + "img/BELFIUS_PAY_BUTTON.b775e9cb.svg";